import InputLabelField from '@/components/form-control/InputLabelField'
import { DATA_TABLE_PIPE } from '@/constant/common'

import { useConfigUI } from '@/features/config/context'
import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Container, Stack, Typography } from '@mui/material'
import { useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-hot-toast'
import * as yup from 'yup'



interface PipesViewProps {
  id?: string
}

const schema = yup
  .object({
    subpipe: yup.string().required('Location is required'),
    controller: yup.string().required('Decoder is required')
  })
  .required()

const PipesView = ({ id }: PipesViewProps) => {
  const { closeSidebar } = useConfigUI()

  const inputRefSiteName = useRef<HTMLInputElement>(null)
  const data = DATA_TABLE_PIPE.find((item) => item.id === id)

  useEffect(() => {
    if (inputRefSiteName.current) {
      inputRefSiteName.current.focus()
    }
  }, [])

  const form = useForm({
    defaultValues: {
      subpipe: '',
      controller: '',
      ...data,
    },
    resolver: yupResolver(schema),
  })

  const handleSave = () => {
    try {
      closeSidebar()
      toast.success('Add Location Success')
    } catch (error) {
      if (error instanceof Error) {
        toast.error(error.message)
      } else {
        console.error('error', error)
      }
    }
  }

  return (
    <Container sx={{ maxWidth: '450px' }}>
      <form onSubmit={form.handleSubmit(handleSave)}>
        <Stack sx={{ padding: '34px 18px' }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: '377px' }}
          >
            <Typography
              sx={{
                fontWeight: '500',
                lineHeight: '14px',
                color: '#000000',
              }}
            >
              {id ? 'Edit SubMainPipe' : 'Add SubMain Pipe'}
            </Typography>
            <Stack direction="row">
              <Button
                color="secondary"
                sx={{ marginRight: '7px', width: '85px' }}
                onClick={() => closeSidebar()}
              >
                Cancel
              </Button>
              <Button color="primary" sx={{ minWidth: '72px' }} type="submit">
                Save
              </Button>
            </Stack>
          </Stack>

          <InputLabelField
            name="subpipe"
            form={form}
            label="Main Pipe"
            placeholder="Main Pipe"
            style={{
              height: 50,
              borderRadius: '4px',
              width: { xs: '377px' },
              marginTop: '8px',
            }}
            padding="8px 16px"
          />
          <InputLabelField
            name="controller"
            form={form}
            label="Decoder"
            placeholder="Decoder"
            style={{
              height: 50,
              borderRadius: '4px',
              width: { xs: '377px' },
              marginTop: '8px',
            }}
            padding="8px 16px"
          />

        </Stack>
      </form>
    </Container>
  )
}

export default PipesView
